<mat-card class="layer-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title-group class="layer-header">
      <mat-card-title>
        <mat-checkbox
          [checked]="layer.isSelected"
          (change)="handleCardCheckboxChange()"
          [matTooltip]="layer.layer"
          [disabled]="uploadedLayersService.layersLoading$()[layer.id]"
        >
          @if (layer.shared_with && layer.shared_with.length > 0) {
            [S]
          } @else {
            [P]
          }
          {{ layer.name }}
        </mat-checkbox>
      </mat-card-title>
      @if (uploadedLayersService.layersLoading$()[layer.id]) {
        <mat-spinner [diameter]="20"></mat-spinner>
      }
    </mat-card-title-group>
  </mat-card-header>

  @if (layer.isSelected || layer.displayError) {
    <mat-card-content class="mat-card-content">
      <div class="mat-card-info">
        @if (layer.displayError) {
          <p class="no-data">This layer could not be displayed.</p>
        } @else if (!layer.sizeState || layer.sizeState.status === 'loading') {
          <mat-spinner [diameter]="20"></mat-spinner>
        } @else if (layer.sizeState.status === 'error') {
          <p class="no-data">Error loading this layer</p>
        } @else {
          <p>Size: {{ layer.sizeState.data }}</p>
        }

        @if (layer.shared_with && layer.shared_with.length > 0) {
          <p>Shared with: {{ layer.shared_with | formatSharedWith }}</p>
        }

        <div class="mat-card-buttons">
          @if (!layer.displayError) {
            <button
              matIconButton
              aria-label="Center map on data"
              matTooltip="Center map on data"
              (click)="uploadedLayersService.uploadedLayerCenterMap(layer)"
            >
              <mat-icon>gps_fixed</mat-icon>
            </button>
          }

          @if (isDownloadLoading$()) {
            <button matIconButton>
              <mat-spinner diameter="24"></mat-spinner>
            </button>
          } @else {
            <button
              matIconButton
              aria-label="Download personal layer"
              matTooltip="Download personal layer"
              (click)="download(layer)"
            >
              <mat-icon>download</mat-icon>
            </button>
          }

          @if (isDeleteLoading$()) {
            <button matIconButton>
              <mat-spinner diameter="24"></mat-spinner>
            </button>
          } @else {
            <button
              matIconButton
              aria-label="Delete personal layers"
              matTooltip="Delete personal layers"
              (click)="deleteLayerWithConfirm(layer)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          }

          <button
            matIconButton
            aria-label="Edit sharing"
            matTooltip="Edit sharing"
            (click)="editPersonalLayer(layer)"
          >
            <mat-icon>group</mat-icon>
          </button>
          @if (!layer.displayError && layer.name?.toLowerCase()?.endsWith('.geojson')) {
            <button
              matIconButton
              aria-label="Edit GeoJSON"
              matTooltip="Edit GeoJSON"
              (click)="openGeojsonEditorDialog()"
            >
              <mat-icon>edit</mat-icon>
            </button>
          }
        </div>
      </div>

      @if (!layer.displayError) {
        <div class="mat-card-symbology">
          <img
            src="{{ imageUrl }}{{ layer.layer_type }}"
            onerror="this.style.visibility = 'hidden'"
          />
        </div>
        <div class="mat-card-symbology">
          <app-custom-symbology [symbology]="symbology ?? []"></app-custom-symbology>
        </div>
      }
    </mat-card-content>
  }
</mat-card>
